import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    const { isLoggedIn, user, isAdmin, login: contextLogin, logout, updateUser } = context;

    const login = async (credentials) => {
        try {
            const endpoint = credentials.isGoogle ? '/api/login/google/' : '/api/login/';
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            });
    
            // Parse the JSON response regardless of success or failure
            const data = await response.json();
            
            if (response.ok) {
                if (data.is_free_account) {
                    // Free account: session-based, redirect to /mailbox (don't store in AuthContext)
                    return { success: true, redirectTo: '/mailbox' };
                }
                // Profile login successful
                contextLogin(data);
                return true;
            } else {
                // Return the error message from the backend
                return { error: data.error || 'Login failed. Please try again.' };
            }
        } catch (error) {
            console.error('Login error:', error);
            return { error: 'Network error. Please check your connection and try again.' };
        }
    };

    return { isLoggedIn, user, isAdmin, login, logout, updateUser };
};